import builder from '../builder';
import SendEmail3 from '../../streamline-icons/bold/send-email-3.svg';

export default builder('IconSendEmail3Bold', SendEmail3);
